import { useNavigate, useLocation } from "react-router-dom";

function useNavigateModal() {
	const location = useLocation();
	const navigateAction = useNavigate();

	const navigate = (path: string) => {
		// navigate(path);
		navigateAction(path, {
			state: {
				background: location,
			},
		});
	};
	return navigate;
}

export default useNavigateModal;
